// @core/api/endpoints/document/export_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExportDocumentRequest,
  ExportDocumentResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Export document
 * Exports a document to the specified format (PDF, HTML, Markdown). For PDF, renders with page layout, watermarks, headers/footers. Returns a download URL or attachment entity.
 */
export async function ExportDocument(
  document_id: string,
  data: ExportDocumentRequest,
  options?: RequestOptions
): Promise<ExportDocumentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id/export`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  const requestOptions = options;
  return client.post<ExportDocumentResponse>(requestPath, data, requestOptions);
}
